import { motion, AnimatePresence } from "framer-motion";

const LogoutPopUp = ({ handleLogout, show, setShow, checked, setChecked }) => {
  const handleClick = () => {
    setShow(false);
    handleLogout();
  };

  const handleClose = () => setShow(false);

  // Animation variants for the overlay
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  // Animation variants for the modal
  const modalVariants = {
    hidden: { 
      opacity: 0,
      scale: 0.8,
      y: -50
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        type: "spring",
        damping: 15,
        stiffness: 300
      }
    },
    exit: {
      opacity: 0,
      scale: 0.8,
      transition: {
        duration: 0.2
      }
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="position-fixed top-0 start-0 w-100 vh-100 bg-dark bg-opacity-75 d-flex justify-content-center align-items-center"
          style={{ zIndex: "300" }}
          variants={overlayVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
        >
          <motion.div
            className="p-4 rounded mx-2 mx-md-0 d-flex flex-column justify-content-center align-items-start position-relative"
            style={{
              background: "#FFC143",
              color: "#391965",
              width: "min(90%, 400px)",
              boxSizing: "border-box",
            }}
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            {/* Close Button */}
            <motion.button
              onClick={handleClose}
              className="position-absolute top-0 start-0 m-2 btn btn-link text-decoration-none"
              style={{ color: "red", fontSize: "1.5rem", lineHeight: 1 }}
              aria-label="Close"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              &times;
            </motion.button>

            <motion.h5 
              className="mb-4 w-100 text-center"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
            >
              تسجيل الخروج
            </motion.h5>

            <motion.div 
              className="form-check mb-4 w-100"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
            >
              <div className="d-flex align-items-center justify-content-between gap-1">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  id="agreeCheck"
                  checked={checked}
                  onChange={(e) => setChecked(e.target.checked)}
                  style={{ 
                    backgroundColor: checked ? "purple" : "white", 
                    borderColor: "purple",
                    cursor: "pointer",
                    marginRight:"5px"
                  }}
                />
                <label className="form-check-label" htmlFor="agreeCheck" style={{ cursor: "pointer" }}>
                  تسجيل الخروج من جميع الأجهزة
                </label>
              </div>
            </motion.div>
            
            <motion.div 
              className="w-100 d-flex justify-content-center"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
            >
              <motion.button
                className="btn w-75 f-size-small py-2"
                onClick={handleClick}
                style={{ 
                  backgroundColor: "purple", 
                  color: "white", 
                  border: "none",
                  borderRadius: "8px"
                }}
                whileHover={{ 
                  scale: 1.05,
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
                }}
                whileTap={{ scale: 0.98 }}
              >
                تسجيل الخروج
              </motion.button>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LogoutPopUp;